
import React from 'react';
import { WeatherCondition } from '@/types/weather';
import WeatherConditionPicker from '@/components/WeatherConditionPicker';
import { Button } from '@/components/ui/button';
import { MessageSquareDot } from 'lucide-react';

interface CustomWeatherConditionPickerProps {
  selectedCondition: WeatherCondition | null;
  onSelectCondition: (condition: WeatherCondition) => void;
  scrollToCustomQuote: () => void;
}

const CustomWeatherConditionPicker: React.FC<CustomWeatherConditionPickerProps> = ({
  selectedCondition,
  onSelectCondition,
  scrollToCustomQuote
}) => {
  return (
    <div className="space-y-3">
      <WeatherConditionPicker 
        selectedCondition={selectedCondition} 
        onSelectCondition={onSelectCondition} 
      />
      
      {/* Custom Quote button with different gradient */}
      <Button 
        onClick={scrollToCustomQuote}
        className="w-full h-40 flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white font-medium"
      >
        <MessageSquareDot className="size-8" />
        <span className="text-sm text-center whitespace-pre-line leading-tight">
          Custom Quote
        </span>
      </Button>
    </div>
  );
};

export default CustomWeatherConditionPicker;
